$('.commitmentToExcellenceSlider').slick({
    infinite: true,
    slidesToShow: 5,
    // slidesToScroll: 5,
    arrows: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                centerMode: true,
                infinite: true,
                dots: true,
                centerPadding: '0'
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                infinite: false,
                centerMode: false,
                dots: true,
                centerPadding: '0'
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                infinite: false,
                centerMode: true,
                dots: true,
                centerPadding: '0'
            }
        }
    ]
});


$('.quantity').each(function() {
  var spinner = $(this),
      input = spinner.find('input[type="number"]'),
      btnUp = spinner.find('.quantity-up'),
      btnDown = spinner.find('.quantity-down'),
      min = input.attr('min'),
      max = input.attr('max');

  btnUp.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

  btnDown.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

});